import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Self-hosted so the app has no external font request: it works offline, keeps
// rendering if a CDN is unreachable, and leaks nothing about who is playing.
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";

import { App } from "./App.js";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
